import React from 'react';
import { Container } from '../components/ui/Container';
import { Button } from '../components/ui/Button';
import { Target, Users, Zap } from 'lucide-react';
export function AboutPage() {
  return <div className="bg-white" data-id="element-316">
      {/* Hero */}
      <div className="bg-gray-900 py-20 lg:py-32 text-center text-white" data-id="element-317">
        <Container data-id="element-318">
          <h1 className="text-4xl font-bold tracking-tight text-white sm:text-5xl mb-6" data-id="element-319">
            About Flowsense
          </h1>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto" data-id="element-320">
            We're on a mission to help every brand unlock the full potential of
            their email marketing flows.
          </p>
        </Container>
      </div>

      {/* Our Story */}
      <section className="py-24" data-id="element-321">
        <Container data-id="element-322">
          <div className="max-w-3xl mx-auto" data-id="element-323">
            <h2 className="text-3xl font-bold tracking-tight text-gray-900 mb-6" data-id="element-324">
              Our Story
            </h2>
            <div className="prose prose-lg text-gray-600" data-id="element-325">
              <p className="mb-4" data-id="element-326">
                Flowsense was founded in 2025 by the founder who spent years
                optimizing email flows for e-commerce brands. After analyzing
                thousands of flows, they noticed a pattern: most brands were
                leaving significant revenue on the table due to simple, fixable
                issues in their automation.
              </p>
              <p className="mb-4" data-id="element-327">
                The problem wasn't lack of effort—it was lack of visibility.
                Brands didn't know which flows were underperforming or what
                specific changes would drive the biggest impact. Manual audits
                were time-consuming and inconsistent.
              </p>
              <p data-id="element-328">
                That's why we built Flowsense: to give every marketer AI-powered
                insights that used to require hiring expensive consultants. Now,
                anyone can optimize their flows with confidence and prove the
                ROI of their work.
              </p>
            </div>
          </div>
        </Container>
      </section>

      {/* Values */}
      <section className="py-24 bg-gray-50" data-id="element-329">
        <Container data-id="element-330">
          <div className="text-center mb-16" data-id="element-331">
            <h2 className="text-3xl font-bold tracking-tight text-gray-900" data-id="element-332">
              Our Values
            </h2>
          </div>
          <div className="grid md:grid-cols-3 gap-8" data-id="element-333">
            {[{
            icon: Target,
            title: 'Impact-Driven',
            desc: 'Every feature we build is designed to drive measurable revenue impact for our customers.'
          }, {
            icon: Users,
            title: 'Customer-First',
            desc: 'We listen to our users and iterate quickly based on their feedback and needs.'
          }, {
            icon: Zap,
            title: 'Innovation',
            desc: 'We leverage cutting-edge AI to solve real marketing problems in novel ways.'
          }].map((value, i) => <div key={i} className="text-center" data-id="element-334">
                <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 mb-6" data-id="element-335">
                  <value.icon className="h-8 w-8 text-white" data-id="element-336" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3" data-id="element-337">
                  {value.title}
                </h3>
                <p className="text-gray-600" data-id="element-338">{value.desc}</p>
              </div>)}
          </div>
        </Container>
      </section>

      {/* Team */}
      <section className="py-24" data-id="element-339">
        <Container data-id="element-340">
          <div className="text-center mb-16" data-id="element-341">
            <h2 className="text-3xl font-bold tracking-tight text-gray-900" data-id="element-342">
              Meet the Team
            </h2>
          </div>
          <div className="flex justify-center" data-id="element-343">
            <div className="text-center max-w-sm" data-id="element-344">
              <img src="https://cdn.magicpatterns.com/uploads/m1RrFSkWrx1tCaoExUYDNQ/diran-1000.webp" alt="Diran George" className="mx-auto h-48 w-48 rounded-full object-cover object-top mb-6" data-id="element-345" />
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-346">
                Diran George
              </h3>
              <p className="text-primary font-medium mb-4" data-id="element-347">Founder</p>
              <p className="text-gray-600" data-id="element-348">
                Digital Marketer and Technologist with 20 years marketing
                technology experience.
              </p>
            </div>
          </div>
        </Container>
      </section>

      {/* Company Info */}
      <section className="py-24 bg-gray-900" data-id="element-349">
        <Container data-id="element-350">
          <div className="text-center max-w-3xl mx-auto" data-id="element-351">
            <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl mb-6" data-id="element-352">
              Join Us on Our Mission
            </h2>
            <p className="text-xl text-gray-300 mb-10" data-id="element-353">
              Flowsense is built by Acciom Limited, dedicated to helping brands
              maximize their email marketing ROI.
            </p>
            <a href="https://go.useflowsense.com/signup" data-id="element-354">
              <Button size="lg" data-id="element-355">Get Started</Button>
            </a>
          </div>
        </Container>
      </section>
    </div>;
}